<template>
  <EdroneTooltip
    :class="$options.name"
    :offset="[0, 16]"
    class="tw:!w-full"
    close-trigger-class-name="close_settings"
    max-width="15rem"
    position="right"
    trigger-event="click"
    type="custom"
    @close="isOpen = false"
    @open="isOpen = true"
  >
    <MainMenuSettingsButton :active="isOpen" />

    <template #custom>
      <div :class="$options.name + 'Content'" class="tw:flex tw:flex-col tw:w-56 tw:max-h-[calc(100vh_-_6.25rem)]">
        <template v-for="(item, index) in settingsTree">
          <template v-if="showItem(item)">
            <div v-if="item.name === 'workspace'" :key="`item-w-${index}`">
              <EdroneDropdownSeparator />
              <MainMenuWorkspace />
              <EdroneDropdownSeparator />
            </div>
            <div v-else :key="`item-${index}`" class="tw:relative">
              <EdroneDropdownItem
                :active="getActiveStatus(item.path)"
                :icon="item.iconName ? item.iconName : 'fa-light fa-circle'"
                :text="item.label"
                :type="getType(item)"
                :unique-id="'main-menu__settings-link--' + item.name"
                close-trigger-class-name="close_settings"
                @click="handleClickLink(item.path)"
              />
              <font-awesome-icon
                v-if="item.hidden"
                class="tw:!text-default-700 tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:text-2xl"
                icon="fa-brands fa-dev"
              />
              <EdroneDropdownSeparator v-if="item.name === 'agents'" />
            </div>
          </template>
        </template>
      </div>
    </template>
  </EdroneTooltip>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import EdroneTooltip from "edrone-components/EdroneTooltip.vue";
import EdroneDropdownItem from "edrone-components/EdroneDropdownItem.vue";
import { MenuItem, settingsTree } from "./MainMenu.helpers.ts";
import { useRoute, useRouter } from "vue-router";
import MainMenuSettingsButton from "vue-app/components/MainMenu/MainMenuSettingsButton.vue";
import EdroneDropdownSeparator from "edrone-components/EdroneDropdownSeparator.vue";
import MainMenuWorkspace from "./MainMenuWorkspace.vue";

export default defineComponent({
  name: "MainMenuSettings",
  components: {
    EdroneDropdownSeparator,
    MainMenuSettingsButton,
    EdroneDropdownItem,
    EdroneTooltip,
    MainMenuWorkspace,
  },
  emits: ["keepHovered"],
  setup(props, context) {
    const router = useRouter();
    const user = window.EDRONE_CONTEXT.user;

    function handleClickLink(link: string | undefined) {
      if (link) {
        if (link === "workspace") {
          return;
        }

        link === "/logout" ? (window.location.href = link) : router.push(link);
      }
    }

    function showItem(item: MenuItem) {
      return !item.hidden || user.isDev;
    }

    const isOpen = ref(false);
    watch(
      () => isOpen.value,
      () => {
        context.emit("keepHovered", isOpen.value);
      }
    );

    const route = useRoute();
    const currentPath = computed(() => route.path);

    function getType(item: MenuItem) {
      return item.disabled && !user.isDev ? "disabled" : "default";
    }

    function getActiveStatus(path: string | undefined) {
      if (!path) {
        return false;
      }
      return currentPath.value.includes(path);
    }

    return {
      handleClickLink,
      settingsTree,
      user,
      showItem,
      isOpen,
      getType,
      getActiveStatus,
    };
  },
});
</script>
<style>
.tippy-box[data-theme~="custom"]:has(.MainMenuSettingsContent) {
  margin: 0.5rem;
}
</style>
